const SET_PRODUCT = 'setProduct'
const SET_PRODUCTS = 'setProducts'

export const mutationTypes = {
  SET_PRODUCT,
  SET_PRODUCTS
}

export const mutations = {
  [SET_PRODUCT] (state, payload) {
    state.product = payload
  },

  [SET_PRODUCTS] (state, payload) {
    state.products = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/module/product/mutations.js